<template>
<div>
<b-container>
  <b-row class="marginal justify-content-around">
    <b-button class="col-md-4 col-5" variant="msstreamblue" @click="newIframe"><font-awesome-icon icon="link"></font-awesome-icon> Create a new Scene List</b-button>
    <b-button class="col-md-4 col-5" variant="mswarning" @click="getIframes">&#x21BA; Refresh</b-button>
  </b-row>
  
  <b-row>
    <b-form-textarea
      id="textarea"
      v-model="postList"
      placeholder=""
      rows="0"
      max-rows="15"
    >
    </b-form-textarea>
  </b-row>

  <b-row>
    <div v-for="iframe in iframes" v-bind:key="iframe.uuid" class="col-xl-12 col-lg-12">
      <b-card no-body border-variant="msstream" class="marginal">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h5 v-if="!iframe._isUpdating">{{iframe.name}} <font-awesome-icon style="cursor: pointer;" icon="pencil-alt" @click="nameUpdating(iframe)"></font-awesome-icon></h5>
          <div v-if="iframe._isUpdating">
          <b-form @submit.prevent="updateName(iframe)">
            <b-input-group prepend="Name: " >
              <b-input type="text" v-model="iframe.name"></b-input> 
              <b-input-group-append>
                <b-button variant="green" type="submit">Submit</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row class="justify-content-around">
            <b-col class="mypanel col-lg-6 col-md-12">
                <h4>
                  Export link 
                  <b-button variant="msstreamblue" @click="copyToClipboard(iframe.link)"><font-awesome-icon icon="clone"></font-awesome-icon> Copy</b-button>
                  <!--<b-button variant="msstreamblue" @click="copyToClipboard(iframe.src)"><font-awesome-icon icon="clone"></font-awesome-icon></b-button>-->
                </h4>
                <p style="color: grey">
                Copy this code and put it in your html page to export a responsive player for the associated video
                <br />
              </p>
              <code :ref="'codeToCopy' + iframe.uuid" style="color:#ba0000">{{iframe.link}}</code>
            </b-col>
            <b-col class="col-lg-5 col-md-12">
              
              <div class="marginalsmall">
                <b-row class="justify-content-center" v-if="previewID !== iframe.uuid">
                  <b-button class="col-md-6 col-8" variant="green" @click="startPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Preview </b-button>
                </b-row>
                <b-row class="justify-content-around" v-if="previewID === iframe.uuid">
                  <b-button class="col-md-5 col-5" variant="quanteec" @click="stopPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Close preview </b-button>
                  <b-button class="col-md-5 col-5" variant="mswarning" @click="refreshPreview(iframe)"><font-awesome-icon icon="video"></font-awesome-icon> Refresh preview </b-button>
                </b-row>
              </div>
              <b-row class="justify-content-center" v-if="previewID === iframe.uuid">

                <div class="resp-container">
                  <iframe id="video-player" class="resp-iframe" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" :src="previewLink"></iframe>
                </div>

              </b-row>
            </b-col>
          </b-row>
          <b-row class="marginaltop justify-content-around">
              <b-button class="col-md-3 col-sm-5 col-5" v-if="$auth.getMyUser().roles.indexOf('manager') > -1" variant="quanteec" @click="selectedIframe = iframe;showModal('confirmDelete')"><font-awesome-icon icon="trash-alt"></font-awesome-icon> Delete Scene List</b-button>
          </b-row>
          
        </b-card-body>
      </b-card>
    </div>
    </b-row>

    <!-- MODALS -->
    <b-modal ref="errorPost" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not create a new export link. Please retry later or contact QUANTEEC at support@quanteec.com.</p>
      <b-row>
        <b-col>
        <b-btn variant="mswarning" block @click="hideModal('errorPost')">Ok</b-btn>
        </b-col>
      </b-row>
  </b-modal>
   <b-modal ref="errorGet" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not receive the list of export links.</p>
      <b-row>
        <b-col>
        <b-btn variant="mswarning" block @click="hideModal('errorGet')">Ok</b-btn>
        </b-col>
      </b-row>
  </b-modal>
  <b-modal ref="errorPut" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not update your export link. Please retry later or contact QUANTEEC at support@quanteec.com.</p>
      <b-row>
        <b-col>
        <b-btn variant="mswarning" block @click="hideModal('errorPut')">Ok</b-btn>
        </b-col>
      </b-row>
  </b-modal>
  <b-modal ref="errorDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not delete your export link. Please retry later or contact QUANTEEC at support@quanteec.com.</p>
      <b-row>
        <b-col>
        <b-btn variant="mswarning" block @click="hideModal('errorDelete')">Ok</b-btn>
        </b-col>
      </b-row>
  </b-modal>

  <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Delete</h3>
      </div>
      <p>Are you sure you want to delete {{selectedIframe.name}} ? The link will no longer work.</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="deleteIframe(selectedIframe.uuid);hideModal('confirmDelete')">Yes, delete</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDelete')">Cancel</b-btn>

      </b-row>
  </b-modal>


  </b-container>
  </div>
</template>

<script>
import {BASE_EXPORT, BASE_READER, EMBED_URL} from '@/services/base-url'
import SceneListService from '@/services/scenelist.service';
import VideoService from "@/services/video.service";
var videoService = new VideoService();
var scenelistService = new SceneListService();
export default {
  name: 'SceneList',
  data: function() {
    return {
      clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
      iframes: [],
      selectedIframe: {},
      previewID: "",
      previewLink: "",
      searchBar: "",
      videos: [],
      selectedVideo: {},
      isVideoSelected: false,
      videoPage: 1,
      videoPageSize: 12,
      baseurl: BASE_READER,
      totalPages: 1,
      postList: JSON.stringify({
        list: [
          {
              "video": "62d95cba-697f-42b8-3470-6d-746c-7561-6665-64-a2d0-17e13a34093bdb",
              "type": "vod",
              "title": "SEQ1",
              "start": 87,
              "end": 100 
          },
          {
              "video": "cea85aa9-8808-448a-3470-6d-746c-7561-6665-64-b7f9-5b0aecae4517db",
              "type": "vod",
              "title": "SEQ2",
              "start": 26,
              "end": 47
          },
          {
              "video": "f4923cc3-56b3-456c-3470-6d-746c-7561-6665-64-9cea-c5518e1159addb",
              "type": "vod",
              "title": "SEQ3",
              "start": 110,
              "end": 150
          }   
        ]
      }, null, 2)
    }
  },
  mounted: function() {
      this.getIframes();
  },
  methods: {
    nameUpdating(iframe) {
      iframe._isUpdating = true;
      this.iframes = this.iframes.splice(0, this.iframes.length);
    },
    imgUrlAlt(event) {
      event.target.src = `/thumbnail.jpg`
    },
    getIframes() {
        scenelistService.getSceneLists(this.$auth.token(), {filter: {client: this.clientView} , sort: {createdDate: -1} })
        .then((data) => {
            this.iframes = data._embedded;
            for (let index in this.iframes) {
              let iframe = this.iframes[index];
              iframe.src = this.createIframeUrlForID(iframe.uuid)
              iframe.link = this.createIframeCompleteForID(iframe.uuid)
            }
        }).catch((err) => {
            this.showModal('errorGet');
        })
    },
    newIframe() {
      var name = "Export Link " + (this.iframes.length + 1);
      let data = JSON.parse(this.postList);
        scenelistService.postSceneList(this.$auth.token(), data)
        .then((data) => {
            data.src = this.createIframeUrlForID(data.uuid)
            data.link = this.createIframeCompleteForID(data.uuid)
            this.iframes.unshift(data);
        }).catch((err) => {
            this.showModal('errorPost');
        })
    },
    updateIframe(iframeID, data) {
      scenelistService.putSceneList(this.$auth.token(), iframeID, data)
        .then((data) => {
            data.src = this.createIframeUrlForID(data.uuid)
            data.link = this.createIframeCompleteForID(data.uuid)
            this.iframes[this.iframes.findIndex(x => x.uuid === iframeID)] = data;
            this.iframes = this.iframes.splice(0, this.iframes.length);
            if (this.previewID === data.uuid) {
              this.refreshPreview(data);
            }
        }).catch((err) => {
            this.showModal('errorPut');
        })
    },
    deleteIframe(iframeID) {
      scenelistService.deleteSceneList(this.$auth.token(), iframeID)
        .then((data) => {
            this.iframes.splice(this.iframes.findIndex(x => x.uuid === iframeID), 1);
            if (this.previewID === iframeID) {
              this.stopPreview();
            }
        }).catch((err) => {
            this.showModal('errorDelete');
        })
    },
    updateName(iframe) {
      delete iframe._isUpdating;
      this.updateIframe(iframe.uuid, {name: iframe.name});
    },
    createIframeUrlForID(iframeID) {
      return EMBED_URL + '/embeded.html?uuid=' + iframeID + '&analyticsID=' + this.clientView + '&sl=1';
    },
    createIframeCompleteForID(iframeID) {
      let result = '<iframe id="video-player" style="width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="';
      let iframeSource = this.createIframeUrlForID(iframeID);

      result += iframeSource;
      result += '"></iframe>';
      return result;
    },
    copyToClipboard(text) {
      this.$copyText(text);
    },
    startPreview(iframe) {
      this.previewID = iframe.uuid; 
      this.previewLink = iframe.src;
    },
    stopPreview() {
      this.previewID = ''; 
      this.previewLink = ''
    },
    refreshPreview(iframe) {
      if (this.previewID === iframe.uuid) {
        this.previewLink = '';
        setTimeout(() => {
          if (this.previewID === iframe.uuid) {
            this.previewLink = iframe.src
          }
        }, 50)
      }
    },

    showModal(modalRef) {
      this.$refs[modalRef].show();
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.resp-container {
  width: 100%;
  padding-top: 56.25%;
  border: 1px solid;
  border-color: lightgrey;
  border-radius: 5px;
  position: relative;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.oldcard {
    border: 5px dashed #ba0000;
  }

  .marginalsmall {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
